import React from 'react';
import { useLocalization } from '../../../context/LocalizationContext';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, message, children, noScroll = false, customLayout = false }) => {
  const { t } = useLocalization();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className={`modal-content ${customLayout ? 'modal-content-custom' : ''} ${noScroll ? 'modal-content-no-scroll' : ''}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {customLayout ? (
          // Custom layout for avatar modal
          <>
            <button className="modal-close-icon" onClick={onClose} aria-label="Close">
              ×
            </button>
            {children}
          </>
        ) : (
          // Original layout for other modals
          <>
            {title && <h2 className="modal-title">{title}</h2>}
            {message && <p className="modal-message">{message}</p>}
            {children}
            <button className="modal-close-btn" onClick={onClose}>
              {t('close')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Modal;
